export default __webpack_public_path__ + "static/pro@mob_2x-a25e308b86aea15fbba2fde7f403937e.webp";